import { useDebugValue } from 'react';
import { useSelector } from 'react-redux';
import { Account, Company } from 'src/models';
import { RootState } from 'src/store';

export const useAccount = (): Account | null => {
  const state = useSelector<RootState, RootState['auth']>(
    (state) => state.auth,
  );

  useDebugValue(state.user);

  return state.user;
};

export const useAccountCompanyList = (): Company[] => {
  const state = useSelector<RootState, RootState['auth']>(
    (state) => state.auth,
  );

  useDebugValue(state.user);

  return state.user?.companies || [];
};

export const useAccountState = (): RootState['auth'] => {
  const state = useSelector<RootState, RootState['auth']>(
    (state) => state.auth,
  );

  useDebugValue(state);

  return state;
};
